import { Engine } from '@/engine/core/Engine';

/**
 * Attendre que le canvas soit prêt
 * Utilise canvasStore.isCanvasTextureMounted pour savoir quand c'est prêt
 */
export async function waitForCanvas(maxWait: number = 5000): Promise<boolean> {
    const startTime = Date.now();

    // Importer le store dynamiquement pour éviter les dépendances circulaires
    const { useCanvasStore } = await import('@/stores/canvas');
    const canvasStore = useCanvasStore();

    while (Date.now() - startTime < maxWait) {
        const engine = Engine.getInstance();
        const canvas = engine?.canvas;

        // 🔍 LOG DÉTAILLÉ toutes les 500ms
        const elapsed = Date.now() - startTime;
        if (elapsed % 500 < 50) {
            const htmlCanvas = canvas?.canvas?.getElement ? canvas.canvas.getElement() : canvas?.canvas?.lowerCanvasEl;
            console.log(`⏳ waitForCanvas check (${elapsed}ms):`, {
                isCanvasTextureMounted: canvasStore.isCanvasTextureMounted,
                hasEngine: !!engine,
                hasCanvas: !!canvas,
                hasEngineCanvas: !!engine._canvas,
                widthCanvas: engine.widthCanvas,
                heightCanvas: engine.heightCanvas,
                hasFabricCanvas: !!canvas?.canvas,
                hasHtmlCanvas: !!htmlCanvas,
                htmlCanvasMethod: canvas?.canvas?.getElement
                    ? 'getElement()'
                    : canvas?.canvas?.lowerCanvasEl
                      ? 'lowerCanvasEl'
                      : 'none'
            });
        }

        // Vérifier via le flag du store ET via Engine
        if (canvasStore.isCanvasTextureMounted) {
            // 🎯 CONDITIONS SIMPLIFIÉES: > 0 au lieu de > 1
            // 🎯 Fabric 6.x: HTMLCanvasElement accessible via .getElement() ou .lowerCanvasEl
            const htmlCanvas = canvas?.canvas?.getElement ? canvas.canvas.getElement() : canvas?.canvas?.lowerCanvasEl;

            if (
                canvas &&
                engine._canvas &&
                engine.widthCanvas > 0 &&
                engine.heightCanvas > 0 &&
                canvas.canvas &&
                htmlCanvas
            ) {
                console.log('✅ Canvas ready!', {
                    hasEngine: !!engine,
                    hasCanvas: !!canvas,
                    hasFabricCanvas: !!canvas.canvas,
                    hasHtmlCanvas: !!htmlCanvas,
                    htmlCanvasMethod: canvas?.canvas?.getElement ? 'getElement()' : 'lowerCanvasEl',
                    widthCanvas: engine.widthCanvas,
                    heightCanvas: engine.heightCanvas
                });
                return true;
            }
        }
        // Attendre 50ms avant de réessayer
        await new Promise((resolve) => setTimeout(resolve, 50));
    }

    console.error('Canvas not ready after', maxWait, 'ms');
    return false;
}
